import { render, staticRenderFns } from "./FileMove.vue?vue&type=template&id=56c508d3"
import script from "./FileMove.vue?vue&type=script&lang=js"
export * from "./FileMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports